import {Component} from '@angular/core';
import {TruffleFound} from '../../../../../model/truffelFound.model';
import {Field} from '../../../../../model/field.model';
import {Line} from '../../../../../model/line.model';
import {Tree} from '../../../../../model/tree.model';
import {ActivatedRoute, Router} from '@angular/router';
import {StateService} from '../../../../../state.service';

@Component({
    selector: 'app-edit-truffle',
    templateUrl: './edit-truffle.component.html',
    styleUrls: ['./edit-truffle.component.css'],
    standalone: false
})
export class EditTruffleComponent {
  field: Field;
  line: Line;
  tree: Tree;
  truffleFound: TruffleFound;
  qualities = ['Erste Klasse', 'Zeite Klasse', 'Unbrauchbar'];
  submitted = false;

  constructor(private route: ActivatedRoute, private router: Router, private stateService: StateService) {
    if (!this.stateService.field && !this.stateService.line && !this.stateService.tree) {
      this.router.navigate( ['field']);
    }
    this.field = this.stateService.field;
    this.line = this.stateService.line;
    this.tree = this.stateService.tree;
    this.truffleFound = this.stateService.truffleFound;
  }

  onSubmit() {
    this.field.lines[this.line.id - 1].trees[this.tree.id - 1].truffleFounds[this.truffleFound.id - 1] = this.truffleFound;
    this.submitted = true;
    this.stateService.editTruffle(this.field);
    this.router.navigate(['field/' + this.field.id + '/line/' + this.line.id + '/tree/' + this.tree.id + '/truffle']);
  }
}
